import { render, staticRenderFns } from "./ManageBrand.vue?vue&type=template&id=4e986b03&"
import script from "./ManageBrand.vue?vue&type=script&lang=js&"
export * from "./ManageBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports